import { Box } from '@chakra-ui/react';

export const FlashIconSVG = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <Box>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
        <path
          d="M8.66667 1.33337L2 9.33337H8L7.33333 14.6667L14 6.66671H8L8.66667 1.33337Z"
          stroke="#2D6670"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
};

export default FlashIconSVG;
